var _ellipse, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgThinUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 72,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 36,
  cy: 52.5,
  rx: 21,
  ry: 10.5,
  stroke: "#6D727F",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 21,
  r: 12,
  stroke: "#6D727F",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})));
export default SvgThinUser;